import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import RadioField from '../app-main/components/reduxForms/fields/RadioField/RadioField';
import { connect } from 'react-redux';
import Button from '../elements-buttons/Button';
import validateCancellationPolicyForm from './forms/validateCancellationPolicyForm';
import onSubmitCancellationPolicy from './forms/onSubmitCancellationPolicy';
import { get, reduce, map } from 'lodash';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const CancellationPolicyForm = ({
  reducedPolicy,
  error,
  handleSubmit,
  isPosting,
  spaceId,
  isEdit,
  intl
}) => {
  return (
    <form className="CancellationPolicyForm" onSubmit={handleSubmit}>
      <div className="flex column w-100">
        <h3><FormattedMessage id="hosting.cancellation_policy_form.heading" defaultMessage="Choose your Cancellation Policy"/></h3>
        <div className="flex middle">
          <img className="lightbulb-icon" src="/web-hosting/assets/images/lightbulb.svg?v=rb" alt="lightbulb" />
          <div className="margin-md-left">
            <FormattedMessage id="hosting.cancellation_policy_form.cancellation_policy_text" defaultMessage="Hosts with more flexible cancellation policies attract more bookings."/>
          </div>
        </div>
        <hr className="w-100" />
        <div className="CancellationPolicyFormRow ps-row-nested">
          <div className="col-sm-11">
            <div className="margin-xl-bottom">
              <FormattedMessage
                id="hosting.cancellation_policy_form."
                defaultMessage="{text} All Bookings are subject to Peerspace’s Grace Period policy which provides a full refund for Bookings cancelled within 24 hours from receipt of a Booking Confirmation but no later than 48 hours prior to the Event start time."
                values={{ text: <b><FormattedMessage id="hosting.cancellation_policy_form.cancellation_grace_period" defaultMessage="Cancellation grace period:"/></b> }}
              />
            </div>
            <Field
              component={RadioField}
              name="cancellation_policy"
              className="flex-wrap margin-xl-bottom ps"
              labelClassName=""
              componentClassName=""
              errorMessage={intl.formatMessage({ id: 'hosting.cancellation_policy_form.error_message', defaultMessage: 'Please select an option' })}
              options={reducedPolicy}
            />
          </div>
        </div>
        <hr className="w-100" />
        <div className="flex space-between">
          {!isEdit && (
            <a
              className="btn btn-default btn-outlined-light"
              href={`/your-space/${spaceId}/cleaning-policy`}
            >
              <FormattedMessage
                id="hosting.cancellation_policy_form.back_link_text"
                defaultMessage="Back"
              />
            </a>
          )}
          <Button
            category="primary"
            className="submit-cta block-xs-left"
            disabled={false}
            attributes={{ 'data-testing-id': 'address' }}
            isLoading={isPosting}
          >
            { isEdit ? <FormattedMessage id="hosting.cancellation_policy_form.done_link_text" defaultMessage="Done"/> : <FormattedMessage id="hosting.cancellation_policy_form.next_link_text" defaultMessage="Next"/>}
          </Button>
        </div>
        <div className="text-danger text-small margin-lg-top">{error}</div>
      </div>
    </form>
  );
};

CancellationPolicyForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  country: PropTypes.string,
  isPosting: PropTypes.bool,
  spaceId: PropTypes.string,
  isEdit: PropTypes.bool,
  reducedPolicy: PropTypes.array,
  intl: intlShape
};

const config = {
  form: 'CANCELLATION_POLICY_FORM',
  validate: validateCancellationPolicyForm,
  onSubmit: onSubmitCancellationPolicy
};

const mapStateToProps = (state) => {
  const space = get(state, 'space.data');
  const isPosting = get(state, 'space.isPosting');
  const cancellationPolicy = get(state, 'env.space.cancellation_policies');
  const reducedPolicy = reduce(cancellationPolicy, (result, value = {}) => {
    result.push({
      id: value.id,
      label: <div className="heavy margin-md-bottom">{value.name}</div>,
      value: value.id,
      component: map(value.description, (val) => <div className="margin-lg-bottom text-gray-600">{val}</div>)
    });
    return result;
  }, []);

  return {
    spaceId: space._id,
    isPosting,
    cancellationPolicy,
    reducedPolicy,
    initialValues: {
      cancellation_policy: get(space, 'cancellation_policy.id')
    }
  };
};

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(CancellationPolicyForm)));
